import { render } from "./IconTrackingCount.vue?vue&type=template&id=d4d7fe6a"
import script from "./IconTrackingCount.vue?vue&type=script&lang=ts"
export * from "./IconTrackingCount.vue?vue&type=script&lang=ts"
script.render = render

export default script